module.exports = __webpack_public_path__ + "static/media/101.a02050ae.jpg";